import React, { useEffect, useRef } from "react";

import { ModalOverlay, ModalWrapper } from "./styles";

export default function Modal({ children, open, onClose, ...rest }) {

  const containerRef = useRef();

  const body = [...document.getElementsByTagName("body")][0];

  function handleClickOutside(event) {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      onClose();
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      body.classList.remove("modal-open");
    };
  }, [body, handleClickOutside]);

  useEffect(() => {
    if (open) {
      body.classList.add("modal-open");
    } else {
      body.classList.remove("modal-open");
    }
  }, [body, open]);

  return (
    <ModalOverlay ref={containerRef} open={open || undefined} {...rest}>
      <ModalWrapper>{children}</ModalWrapper>
    </ModalOverlay>
  );
}
